import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.handleClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside.bind(this));
  }

  toggle(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle("hidden");

    // Update aria-expanded
    const button = event.currentTarget;
    const isExpanded = !this.menuTarget.classList.contains("hidden");
    button.setAttribute("aria-expanded", isExpanded);

    // Rotate chevron icon
    const chevron = button.querySelector("svg");
    if (chevron) {
      chevron.style.transform = isExpanded ? "rotate(180deg)" : "rotate(0deg)";
    }
  }

  hide() {
    this.menuTarget.classList.add("hidden");
    const button = this.element.querySelector("button");
    if (button) {
      button.setAttribute("aria-expanded", "false");
      const chevron = button.querySelector("svg");
      if (chevron) {
        chevron.style.transform = "rotate(0deg)";
      }
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }
}
